import React, { useEffect, useState } from "react";
import "./DimensionsTab.css";
import { Number } from "src/components/Input/Number";
import Text from "src/components/Text/Text";
import { useConfiguration } from "src/contexts/ConfigurationContext";
// @ts-ignore
import isEqual from "lodash/isEqual";
import SelectUnselectExtended from "src/components/Input/SelectUnselectExtended/SelectUnselectExtended";
import { MinMaxLabel } from "src/components/Input/Number/MinMaxLabel";


const DimensionsTab: React.FC = () => {
  const { state, setDimensions } = useConfiguration();
  const [showOverhang, setShowOverhang] = useState(false);

  const overhangMin = 0;
  const overhangMax = 350;
  const SIDE_OVERHANG_MIN_MM = 150;

  function clampSideOverhangMm(
    next: number,
    prev: number,
    maxMm: number,
  ): number {
    if (next <= 0) return 0;
    if (next > maxMm) return maxMm;
    if (next >= SIDE_OVERHANG_MIN_MM) return next;
    return next < prev ? 0 : SIDE_OVERHANG_MIN_MM;
  }

  const patchSideOverhang =
    (key: "overhangLeft" | "overhangRight") => (value: number) =>
      handleChangeDimension(
        clampSideOverhangMm(value, state.dimensions[key], overhangMax),
        key,
      );

  const handleChangeDimension = (value: number, key: string) => {
    const updatedDimensions = { ...state.dimensions };
    // @ts-ignore
    updatedDimensions[key] = value;

    if (
      state.storages.left &&
      state.storages.right &&
      updatedDimensions.width <
      updatedDimensions.leftStorageWidth + updatedDimensions.rightStorageWidth
    ) {
      updatedDimensions.width =
        updatedDimensions.leftStorageWidth +
        updatedDimensions.rightStorageWidth;
    }

    if (isEqual(updatedDimensions, state.dimensions)) return;
    setDimensions(updatedDimensions);
  };

  const selectedNames = () => {
    const overhangs = [];
    const { overhangLeft, overhangRight, overhangFront, overhangBack } =
      state.dimensions;

    if (overhangLeft > 0) {
      overhangs.push(`Links: ${overhangLeft / 10}cm`);
    }
    if (overhangRight > 0) {
      overhangs.push(`Rechts: ${overhangRight / 10}cm`);
    }
    if (overhangFront > 0) {
      overhangs.push(`Voorzijde: ${overhangFront / 10}cm`);
    }
    if (overhangBack > 0) {
      overhangs.push(`Achterzijde: ${overhangBack / 10}cm`);
    }

    return overhangs.join(", ");
  };

  return (
    <div className="dimensions-tab">
      <Text content="Kies uw afmetingen" />
      <Number
        key={"house-width"}
        value={state.dimensions.width}
        onChange={(value: number) => handleChangeDimension(value, "width")}
        label="Breedte"
        // subStep={100}
        min={2500}
        max={8000}
        step={100}
        unit={"cm"}
      />
      <Number
        key={"house-depth"}
        value={state.dimensions.depth}
        onChange={(value: number) => handleChangeDimension(value, "depth")}
        label="Diepte"
        // subStep={100}
        min={2500}
        max={4000}
        step={100}
        unit={"cm"}
      />
      {(state.roofType === "platdak" || state.roofType === "basic") && (
        <SelectUnselectExtended
          name="Dakoverstek"
          isSelected={selectedNames().length > 0}
          onSelect={() => { }}
          onUnselect={() => { }}
          showComponent={showOverhang}
          onShowComponentToggle={setShowOverhang}
          selectedNames={selectedNames()}
          imageUrl={"./images/overstack.png"}
          Component={() => (
            <>
              <MinMaxLabel min={overhangMin} max={overhangMax} unit={"cm"} />
              <Number
                key={"house-overhang-front"}
                value={state.dimensions.overhangFront}
                onChange={(value: number) =>
                  handleChangeDimension(value, "overhangFront")
                }
                label="Overstek Voorzijde"
                // subStep={10}
                min={overhangMin}
                max={overhangMax}
                step={10}
                unit={"cm"}
                showSubLabel={false}
              />
              <Number
                key={"house-overhang-right"}
                value={state.dimensions.overhangRight}
                onChange={patchSideOverhang("overhangRight")}
                label="Overstek Rechts"
                // subStep={10}
                min={overhangMin}
                max={overhangMax}
                step={10}
                unit={"cm"}
                showSubLabel={false}
              />
              <Number
                key={"house-overhang-back"}
                value={state.dimensions.overhangBack}
                onChange={(value: number) =>
                  handleChangeDimension(value, "overhangBack")
                }
                label="Overstek Achterzijde"
                // subStep={10}
                min={overhangMin}
                max={overhangMax}
                step={10}
                unit={"cm"}
                showSubLabel={false}
              />
              <Number
                key={"house-overhang-left"}
                value={state.dimensions.overhangLeft}
                onChange={patchSideOverhang("overhangLeft")}
                label="Overstek Links"
                // subStep={10}
                min={overhangMin}
                max={overhangMax}
                step={10}
                unit={"cm"}
                showSubLabel={false}
              />
            </>
          )}
        />
      )}
    </div>
  );
};

export default DimensionsTab;
